// extracted by mini-css-extract-plugin
export default {"receipt":"receipt_receipt__K0V4w","receiptPartner":"receipt_receiptPartner__oio33","receiptFooter":"receipt_receiptFooter__h4egz"};